import React from 'react';

interface MetricInfoIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

/**
 * MetricInfoIcon Component
 * 
 * A circular icon with a right-pointing arrow used in metric cards and performance displays.
 * Indicates additional information is available or action can be taken.
 * 
 * @component
 * @example
 * ```tsx
 * // Default (blue color)
 * <MetricInfoIcon size={24} />
 * 
 * // Custom color
 * <MetricInfoIcon size={24} color="#6b7280" />
 * ```
 */
export const MetricInfoIcon: React.FC<MetricInfoIconProps> = ({ 
  size = 24, 
  color = '#0088ff',
  ...props 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="2.5" 
        d="m12 16 4-4m0 0-4-4m4 4H8m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default MetricInfoIcon;

